import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">Vector Accelerator C++ Library</h2>
      <div className="text-justify">
        <p>
          Vector Accelerator(patent pending) is designed for cases where user simply wants to process multiple samples of data and utilize SIMD(AVX2 or AVX512) and multi-thread to gain a x200 magnitude increase in speed performance. Writing Multi-thread safe code for large projects can be challenging. This library  transforms your calculations into versions which can be safely executed in parallel even when the original code is not. Minimal code changes made to the original serial code and large projects can be accelerated.
        </p>
      </div>
      <div className="row mt-30">
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-diamond"></span>
              Efficient memory
            </h4>
            <p>Very large computations are possible. Efficient memory use and code folding techniques.</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-sync"></span>
              Automatic vectorization
            </h4>
            <p>Take full advantage of AVX2 or AVX512 native CPU vectorization</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-rocket"></span>
              Multi-thread safe
            </h4>
            <p>Output function is safe to execute in parallel even when the original code is not.</p>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-eye"></span>
              Easy integration
            </h4>
            <p>No template expressions. Unique active type allows to reuse in-memory objects.</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-code"></span>
              Automatically tested
            </h4>
            <p>Automatically tested on multiple platforms/compilers using rich set of test cases</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-eye"></span>
              Easy to maintain
            </h4>
            <p>Keeps original code readable and easy to maintain</p>
          </div>
        </div>
      </div>
      <Contact/>
     See BENCHMARKS for example performance.
    </div>
  </Layout>
)